import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
// @material-ui/core components
// core components
import GridContainer from "../../components/Grid/GridContainer.js";

import Card from "../../components/Card/Card.js";
import GridItem from "../../components/Grid/GridItem.js";
import Button from "../../components/CustomButtons/Button.js";

import { getCriterion } from "../../api/apiCriteria.js";
import { editCriterion } from "../../api/apiCriteria.js";
import Criterion from "../../components/Criteria/Criterion";
import { isAuthenticated } from "../../utils/authService";
import { validateCriterion } from "../../utils/criterionValidation";
import { showWarningToast } from "../../utils/toastMessages";
import { ToastContainer } from "react-toastify";
import CardFooter from "../../components/Card/CardFooter";
import CardBody from "../../components/Card/CardBody";

export default function EditCriterion() {
  const { id } = useParams();
  const [criterionData, setCriterionData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const retData = await getCriterion(id);
        const data = {
          id: retData.id,
          data: retData,
        };
        setCriterionData(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const history = useHistory(); // Initialize useHistory hook

  const updateCriterionData = (id, newData) => {
    setCriterionData({
      id: id,
      data: newData,
    });
  };

  const handleSubmit = async () => {
    let dataValid = validateCriterion(criterionData.data);
    if (!dataValid.success) {
      showWarningToast({
        title: dataValid.title,
        message: dataValid.message,
      });
    } else {
      const dataToSend = criterionData.data;
      try {
        await editCriterion(id, dataToSend);
        history.push("/admin/showallcriteria");
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      {!isAuthenticated() && (
        <p>Izmjene kriterijuma dozvoljene samo administratorima!</p>
      )}
      {isAuthenticated() && (
        <>
          <ToastContainer />
          <div>
            <GridContainer justify="center">
              <GridItem xs={12} sm={6} md={6}>
                <Card>
                  <CardBody>
                    <Criterion
                      key={criterionData.id}
                      id={criterionData.id}
                      data={criterionData.data}
                      updateData={updateCriterionData}
                    />
                  </CardBody>
                  <CardFooter>
                    <Button color="success" onPress={handleSubmit}>
                      Sačuvaj izmjene
                    </Button>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
        </>
      )}
    </>
  );
}
